import { Enum } from './Enum';

export class PODShuffleStatus extends Enum {
  translationKey = 'podShuffleStatus';

  static asArray: PODShuffleStatus[] = [];

  static byKey: { [name: string]: PODShuffleStatus } = {};

  static readonly PENDING = new PODShuffleStatus('PENDING');

  static readonly COMPLETE = new PODShuffleStatus('COMPLETE');

  static readonly ERROR = new PODShuffleStatus('ERROR');

  constructor(public readonly value: string) {
    super();
    PODShuffleStatus.asArray.push(this);
    PODShuffleStatus.byKey[value] = this;
  }

  static getColor(status: PODShuffleStatus | string) {
    const value = typeof status === 'string' ? status : status.value;
    switch (value) {
      case PODShuffleStatus.PENDING.value:
        return 'warning';
      case PODShuffleStatus.COMPLETE.value:
        return 'success';
      case PODShuffleStatus.ERROR.value:
        return 'error';
      default:
        return 'info';
    }
  }
}
